import PortalIdParser from 'PortalIdParser';
import { fetchOnboardingSettings, patchOnboardingSettings } from './api/onboardingSettingsApi';
import { setGroupKey } from './api/userContextApi';
export const ONBOARDING_VIEWS = {
  SALES: 'sales',
  MARKETING: 'marketing',
  SERVICE: 'service',
  CMS: 'cms',
  OPS: 'ops',
  SUITE: 'suite',
  BUSINESS_BOX: 'businessBox',
  USE_CASE: 'useCase'
};
export const getOnboardingSettings = (userId, portalId) => {
  return fetchOnboardingSettings(userId, portalId);
};
export const setOnboardingSettings = (onboardingSettings, userId, portalId = PortalIdParser.get(), options) => {
  return patchOnboardingSettings(onboardingSettings, userId, portalId, options);
};
export const setHubOnboardingSettings = (view, settings, userId, portalId = PortalIdParser.get()) => {
  const onboardingSettings = {
    views: {
      [view]: settings
    },
    selectedView: view
  };
  const settingsRequests = [setOnboardingSettings(onboardingSettings, userId, portalId)];

  if (settings.groupKey) {
    settingsRequests.push(setGroupKey(settings.groupKey));
  }

  return Promise.all(settingsRequests);
};